import request from './request';
// 认证相关 API
export const authApi = {
    // 用户登录
    login: (data) => {
        return request.post('/auth/login', data);
    },
    // 用户登出
    logout: () => {
        return request.post('/auth/logout');
    },
    // 获取用户信息
    getProfile: () => {
        return request.get('/user/profile');
    },
    // 更新用户信息
    updateProfile: (data) => {
        return request.put('/user/profile', data);
    },
    // 修改密码
    changePassword: (data) => {
        return request.put('/user/password', data);
    },
    // 刷新 Token
    refreshToken: () => {
        return request.post('/auth/refresh');
    }
};
export default authApi;
